import { render, staticRenderFns } from "./LabLabel.vue?vue&type=template&id=e217c23a&scoped=true&"
import script from "./LabLabel.vue?vue&type=script&lang=js&"
export * from "./LabLabel.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=e217c23a&scoped=true&lang=css&"
import style1 from "./LabLabel.vue?vue&type=style&index=1&id=e217c23a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e217c23a",
  null
  
)

export default component.exports